module.exports = __webpack_public_path__ + "img/slider-2.717ec5c0.jpg";